import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Alert } from '@mui/material';
import { Field } from 'react-final-form';
import TrainerSelectFieldAdapter from 'components/shared/field-adapters/TrainerSelectFieldAdapter';

function SessionFieldsTrainerSelection({ values }) {
  const { t } = useTranslation(['labels', 'sessions']);

  const trainers = useSelector((state) => state.trainer.data.trainers);
  const trainerStatus = useSelector((state) => state.trainer.status.general);

  // Detectar mismatch: entrenador seleccionado que no tiene la categoría elegida
  const selectedTrainer = trainers.find((tr) => String(tr.id) === String(values.trainer_id));
  const trainerSpecialtyIds =
    selectedTrainer?.specialties?.map((s) => parseInt(s.id, 10)) || [];
  const sessionTypeId = values.session_type_id ? parseInt(values.session_type_id, 10) : null;
  const trainerMismatch =
    !!values.trainer_id &&
    !!sessionTypeId &&
    trainerSpecialtyIds.length > 0 &&
    !trainerSpecialtyIds.includes(sessionTypeId);

  return (
    <>
      <Field
        id="trainer_id"
        name="trainer_id"
        component={TrainerSelectFieldAdapter}
        label={t('trainer', { count: 1, ns: 'labels' })}
        status={trainerStatus}
        trainers={trainers}
        emptyMessage={t('trainerNotAvailable', { ns: 'sessions' })}
        disabled={!values.client_id || !values.session_type_id}
      />
      {trainerMismatch && (
        <Alert severity="warning" sx={{ mt: 1 }}>
          {t('noCategoryTrainers', { ns: 'sessions' })}
        </Alert>
      )}
    </>
  );
}

SessionFieldsTrainerSelection.propTypes = {
  values: PropTypes.object.isRequired
};

export default SessionFieldsTrainerSelection;
